export const API_CONFIG = {
    BASE_URL: process.env.NODE_ENV === 'production' 
      // ? 'https://stockkhata.in' 
      ? 'https://stockkhata-webapp.onrender.com' 
      : 'http://localhost:5000',
    AUTH_PATH: '/auth',
    STOCKS_PATH: '/stocks'
  };